var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperClipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4807 7.23944L7.28501 12.7745C6.31851 14.4485 4.17795 15.0221 2.50392 14.0556V14.0556C0.829897 13.0891 0.256334 10.9485 1.22283 9.27452L5.26763 2.26873C5.92892 1.12334 7.39351 0.730904 8.5389 1.39219V1.39219C9.68428 2.05348 10.0767 3.51808 9.41543 4.66346L6.26145 10.1263C5.90537 10.7431 5.11674 10.9544 4.49999 10.5983V10.5983C3.88325 10.2422 3.67193 9.4536 4.02801 8.83686L5.48018 6.32163",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClipIcon);
export default __webpack_public_path__ + "static/media/PaperClipIcon.ed763998.svg";
export { ForwardRef as ReactComponent };